import * as React from 'react';
import { DatasheetElementResizeDirection } from '../../../../hooks/datasheet-element.controller';

export type ResizerProps = {
  onMouseDown: (e: React.MouseEvent<HTMLDivElement>, direction: DatasheetElementResizeDirection) => void;
  className?: string;
  direction: DatasheetElementResizeDirection;
};

export const Resizer: React.FC<ResizerProps> = (props) => {
  const { onMouseDown, className, direction } = props;

  const handleMouseDown = React.useCallback((e: React.MouseEvent<HTMLDivElement>) => {
    onMouseDown(e, direction);
  }, [onMouseDown, direction]);

  return (
    <div
      className={className}
      onMouseDown={handleMouseDown}
    />
  );
};